var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterInstarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3329 9.33356C21.3329 8.59718 21.9299 8.00022 22.6663 8.00022C23.4026 8.00022 23.9996 8.59718 23.9996 9.33356C23.9996 10.0699 23.4026 10.6669 22.6663 10.6669C21.9299 10.6669 21.3329 10.0699 21.3329 9.33356Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 9.66689C12.5018 9.66689 9.66626 12.5024 9.66626 16.0002C9.66626 19.498 12.5018 22.3336 15.9996 22.3336C19.4974 22.3336 22.3329 19.498 22.3329 16.0002C22.3329 12.5024 19.4974 9.66689 15.9996 9.66689ZM11.6663 16.0002C11.6663 13.607 13.6064 11.6669 15.9996 11.6669C18.3928 11.6669 20.3329 13.607 20.3329 16.0002C20.3329 18.3935 18.3928 20.3336 15.9996 20.3336C13.6064 20.3336 11.6663 18.3935 11.6663 16.0002Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0106 3.77758C18.3885 3.26099 13.6107 3.26099 8.98862 3.77758C6.30588 4.07741 4.1401 6.19076 3.82469 8.88747C3.27198 13.6132 3.27198 18.3872 3.82469 23.113C4.1401 25.8097 6.30588 27.923 8.98862 28.2229C13.6107 28.7395 18.3885 28.7395 23.0106 28.2229C25.6933 27.923 27.8591 25.8097 28.1745 23.113C28.7272 18.3872 28.7272 13.6132 28.1745 8.88747C27.8591 6.19076 25.6933 4.07741 23.0106 3.77758ZM9.21076 5.7652C13.6852 5.26511 18.314 5.26511 22.7885 5.7652C24.5619 5.96341 25.9826 7.3629 26.1881 9.1198C26.7227 13.6912 26.7227 18.3093 26.1881 22.8806C25.9826 24.6375 24.5619 26.037 22.7885 26.2352C18.314 26.7353 13.6852 26.7353 9.21077 26.2352C7.43729 26.037 6.01664 24.6375 5.81115 22.8806C5.27649 18.3093 5.27649 13.6912 5.81115 9.1198C6.01664 7.3629 7.43729 5.96341 9.21076 5.7652Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterInstarIcon);
export default __webpack_public_path__ + "static/media/footer_instar_icon.8944d3ff2fe5baa24010a654cf61fa2a.svg";
export { ForwardRef as ReactComponent };